import { render, staticRenderFns } from "./singlePlayCard.vue?vue&type=template&id=44595d6e&scoped=true"
import script from "./singlePlayCard.vue?vue&type=script&lang=js"
export * from "./singlePlayCard.vue?vue&type=script&lang=js"
import style0 from "./singlePlayCard.vue?vue&type=style&index=0&id=44595d6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44595d6e",
  null
  
)

export default component.exports